if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          if(this.submitButton.getAttribute('data-fresh_food_delivery') == 1){
            formData.append("properties[FreshFoodDelivery]", "true")
          }
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            console.log("config", config);
            let getCartInfo = null;

            if (
              response.product_type == "frozen_food" ||
              response.id == "49970641666312" ||
              response.id == "50051770581256" ||
              response.id == "50193688428808" 
            ) {
              getCartInfo = await getCart(this.cart);
              if (getCartInfo != null) response = getCartInfo;
            }

            if(this.submitButton.getAttribute('data-fresh_food_delivery') == 1){
              getCartInfo = await getCartDelivery(this.cart);
              if (getCartInfo != null) response = getCartInfo;
              
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  async function getCart(cart) {
    let cartInfo = await fetch("https://helloasia.ch/cart.js");
    let cartData = await cartInfo.json();
    console.log(1231231231312312312)
    console.log(document.querySelector("cart-drawer"));
    let hasFrozenBag = cartData.items.some(
      (item) => item.product_id === 9552743039240
    );

    if (!hasFrozenBag) {
      console.log(this.cart);
      // Nếu không có frozen bag, thêm vào cart
      const payload = {
        items: [
          {
            id: 50342804390152,
            quantity: 1,
          },
        ], // Mục ban đầu
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };

      let bagFozen = await fetch(`https://helloasia.ch/cart/add.js`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });
      bagFozen = await bagFozen.json();

      return bagFozen;
    }
    return null;
  }

  async function getCartDelivery(cart) {
    let cartInfo = await fetch("https://helloasia.ch/cart.js");
    let cartData = await cartInfo.json();
    console.log(document.querySelector("cart-drawer"));
    let hasFreshFoodDelivery = cartData.items.some(
      (item) => item.product_id === 10468048044296
    );

    if (!hasFreshFoodDelivery) {
      console.log(this.cart);
      // Nếu không có frozen bag, thêm vào cart
      const payload = {
        items: [
          {
            id: 52208339288328,
            quantity: 1
          },
        ], // Mục ban đầu
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };

      let freshFoodDelivery = await fetch(`https://helloasia.ch/cart/add.js`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });
      freshFoodDelivery = await freshFoodDelivery.json();

      return freshFoodDelivery;
    }
    return null;
  }
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("scroll", this.update.bind(this));
    this.update();
    document
      .querySelector("footer")
      .classList.add("sticky-cart-modal_bottom_padding");
  }
  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains("show-modal")
    ) {
      this.classList.add("show-modal");
      document.querySelector("body").classList.add("modal__sticky-cart");
    }
    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains("show-modal")
    ) {
      this.classList.remove("show-modal");
      document.querySelector("body").classList.remove("modal__sticky-cart");
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define("sticky-cart-modal", stickyCartModal);

class productFormFix extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".add-to-cart-btn-config");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    if (this.buttons.length > 0) {
      this.buttons.forEach((button) => {
        button.addEventListener("click", this.onSubmit.bind(this));
      });
    } else {
      console.error(
        'No buttons with class "add-to-cart-btn-config" found in the component'
      );
    }
    this.buttonAll = document.getElementById("add-all-to-cart");
    this.buttonAll.addEventListener("click", this.onSubmitAll.bind(this));
  }

  onSubmit(evt) {
    console.log(evt.target);
    evt.preventDefault();
    let items = [];
    let productElement = this.closest(".product_blog");
    let variantInput = productElement.querySelector('input[name="id"]');
    let quantityInput = productElement.querySelector(".product-quantity");
    items.push({
      id: variantInput.value,
      quantity: parseInt(quantityInput, 10),
    });

    const payload = {
      items: items, // Mục ban đầu
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    fetch("https://helloasia.ch/en/cart/add.js", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form-fix",
          productVariantId: 49820317614344,
        });
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(data);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(data);
        }
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  onSubmitAll(evt) {
    evt.preventDefault();
    let items = [];
    let productElement = document.querySelectorAll(".product_blog");
    productElement.forEach((product) => {
      let variantInput = product.querySelector('input[name="id"]');
      let quantityInput = product.querySelector(".product-quantity");
      let productAvailable = product.getAttribute("data-product-available");
      console.log(productAvailable);
      if (variantInput && quantityInput && productAvailable == "true") {
        let variantId = variantInput.value;
        let quantity = quantityInput.value;

        items.push({
          id: variantId,
          quantity: parseInt(quantity, 10),
        });
      }
    });

    const payload = {
      items: items, // Mục ban đầu
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    fetch(`https://helloasia.ch/cart/add.js`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form-fix",
          productVariantId: 49820317614344,
        });
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(data);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(data);
        }
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
customElements.define("product-form-fix", productFormFix);
